import React, { useState } from 'react';
import './Gatekeeper.css';

const Gatekeeper = ({ children }) => {
    const [password, setPassword] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(
        localStorage.getItem('wedding_auth') === 'true'
    );
    const [error, setError] = useState(false);

    const handleLogin = (e) => {
        e.preventDefault();
        if (password.toLowerCase() === process.env.REACT_APP_SITE_PASSWORD?.toLowerCase()) {
            localStorage.setItem('wedding_auth', 'true');
            setIsAuthorized(true);
        } else {
            setError(true);
        }
    };

    if (isAuthorized) {
        return <>{children}</>;
    }

    return (
        <div className="gatekeeper-container">
            <div className="gatekeeper-card">
                <h1>Vanessa & Kay</h1>
                <p className="gatekeeper-subtitle">Please enter the password from your invitation to enter our wedding site.</p>
                <form onSubmit={handleLogin} className="gatekeeper-form">
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setError(false);
                        }}
                        placeholder="Password"
                        className={`gatekeeper-input ${error ? 'error' : ''}`}
                    />
                    {error && <p className="gatekeeper-error">Incorrect password. Please try again!</p>}
                    <button type="submit" className="btn">Enter</button>
                </form>
            </div>
        </div>
    );
};

export default Gatekeeper;